import * as R from 'ramda'

const UNANSWERED = 'unanswered'
const CANCELLED = 'cancelled'
const ISSUED = 'issued'

// A row is written BEFORE the provider is asked, so the request can carry the
// row's id as its clientId. A row with no `invoice` is therefore one the
// provider never answered for -- coact reads the missing field back as null,
// which is what used to crash every page showing this table.
function invoiceRowState(row) {
  const invoice = R.prop('invoice', row)

  if (!invoice) return UNANSWERED
  if (invoice.canceledAt) return CANCELLED

  return ISSUED
}

// What the action column says, or null when the row can be voided and the
// caller should render the button instead.
//
// Nothing on the client can tell a refusal from a reply that was lost, so an
// unanswered row says only that the attempt did not finish. There is also
// nothing to void on it: cancelling needs a provider invoice id the row has not
// got, so offering the button could only produce a server error.
function invoiceRowLabel(row) {
  const state = invoiceRowState(row)

  if (state === UNANSWERED) return '開立未完成'
  if (state === CANCELLED) return '已作廢'

  return null
}

export { UNANSWERED, CANCELLED, ISSUED, invoiceRowState, invoiceRowLabel }
